import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageIssueComment} from '@/api/model/interfaces';

export default class DrawingPackageIssueCommentOdata extends OdataManager<DrawingPackageIssueComment> {}
